import { useParams } from "react-router-dom";

export const useDefaultStoreProjectAssigneeId = () => {
  const { assigneeId } = useParams();
  return assigneeId as string;
};
